import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axiosInstance";

export const fetchGroups = createAsyncThunk(
    "groups/fetchGroups",
    async (params, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get("api/group", { params });
            const result = response.data;
            return {
                items: result?.data?.items || (Array.isArray(result?.data) ? result.data : result?.data?.groups || result?.groups || (Array.isArray(result) ? result : [])),
                pagination: result?.data?.pagination || null
            };
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// Separate thunk for fetching the full unpaginated group list.
// Used by AddTaskModal dropdown — must NOT share state with the paginated table.
export const fetchAllGroups = createAsyncThunk(
    "groups/fetchAllGroups",
    async (_, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get("api/group");
            const result = response.data;
            const items = result?.data?.items
                || (Array.isArray(result?.data) ? result.data : null)
                || result?.data?.groups
                || result?.groups
                || (Array.isArray(result) ? result : []);
            return items;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);
